import React, { useEffect, useState } from 'react';
import { Users, Loader2 } from 'lucide-react';
import api from '../services/api';
import { toast } from 'sonner';

/**
 * Privacy toggle: when ON, the user appears in Villages as their avatar + first
 * name. Default OFF (anonymous silhouette). Consent-based, revocable anytime.
 */
const VillageOptinCard = () => {
  const [on, setOn] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.getVillageOptin().then((r) => setOn(!!r.data?.opted_in)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const toggle = async () => {
    const next = !on;
    setSaving(true);
    try {
      const r = await api.setVillageOptin(next);
      setOn(!!r.data?.opted_in);
      toast.success(next ? 'You now appear in Villages as your avatar + first name.' : "You're anonymous in Villages again.");
    } catch (e) {
      toast.error('Could not update that.');
    } finally { setSaving(false); }
  };

  return (
    <div className="hpme-card p-5" data-testid="village-optin-card">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-3">
          <span className="w-10 h-10 rounded-full bg-primary/15 border border-primary/40 grid place-items-center shrink-0">
            <Users className="w-5 h-5 text-primary" />
          </span>
          <div>
            <h3 className="font-secondary font-bold text-lg text-white leading-tight">Appear in Villages</h3>
            <p className="text-xs text-zinc-400 mt-1 max-w-sm">
              When ON, others see your <span className="text-zinc-200">avatar + first name</span> as you contribute. When OFF, you're an anonymous traveller. You can change this anytime.
            </p>
          </div>
        </div>
        <button
          onClick={toggle}
          disabled={loading || saving}
          data-testid="village-optin-toggle"
          className={`relative w-12 h-7 rounded-full transition-colors shrink-0 ${on ? 'bg-primary' : 'bg-zinc-700'} disabled:opacity-50`}
          aria-pressed={on}
        >
          {saving ? (
            <Loader2 className="w-4 h-4 animate-spin text-black absolute top-1.5 left-4" />
          ) : (
            <span className={`absolute top-1 w-5 h-5 rounded-full bg-white transition-all ${on ? 'left-6' : 'left-1'}`} />
          )}
        </button>
      </div>
    </div>
  );
};

export default VillageOptinCard;
